"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CxNavbar = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const core_1 = require("@mantine/core");
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("@mantine/hooks");
const faChevronCircleLeft_1 = require("@fortawesome/free-solid-svg-icons/faChevronCircleLeft");
const styles_1 = require("@mantine/styles");
const useStyles = (0, core_1.createStyles)((theme) => ({
    appTitle: {
        width: "70%",
        [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
            width: "auto"
        }
    },
    burger: {
        [theme.fn.largerThan("xs")]: {
            display: "none"
        }
    },
    resize: {
        [theme.fn.smallerThan("xs")]: {
            display: "none"
        }
    },
    hide: {
        display: "none"
    },
    navbar: {
        backgroundColor: theme.other.mainBackgroundColor
        //paddingBottom: 0
    },
    navbarHeader: {
        padding: theme.spacing.md,
        paddingTop: 0,
        marginLeft: -theme.spacing.md,
        marginRight: -theme.spacing.md,
        color: theme.colorScheme === "dark" ? theme.white : theme.black
        //borderBottom: `1px solid ${
        //    theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        //}`
    },
    navbarLinks: {
        marginLeft: -theme.spacing.md,
        marginRight: -theme.spacing.md
    },
    navbarLinksInner: {
        paddingTop: theme.spacing.xl,
        paddingBottom: theme.spacing.xl
    },
    navbarItemControl: {
        fontWeight: 500,
        display: "block",
        width: "100%",
        padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        fontSize: theme.fontSizes.sm,
        "&:hover": {
            backgroundColor: theme.colorScheme === "dark"
                ? theme.colors.dark[7]
                : theme.colors.gray[0],
            color: theme.colors[theme.primaryColor][7]
        }
    },
    navbarItemLink: {
        display: "block",
        textDecoration: "none",
        padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
        paddingLeft: `${theme.spacing.xs + theme.spacing.xs}px`,
        marginLeft: 24,
        fontSize: theme.fontSizes.sm,
        transition: "all 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
        color: theme.colorScheme === "dark"
            ? theme.colors.dark[0]
            : theme.colors.gray[7],
        borderLeft: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`,
        "&:hover": {
            backgroundColor: theme.colorScheme === "dark"
                ? theme.colors.dark[7]
                : theme.colors.gray[0],
            color: theme.colors[theme.primaryColor][7],
            textDecoration: "none"
        }
    },
    navbarItemLinkActive: {
        backgroundColor: theme.colorScheme === "dark"
            ? theme.colors.dark[7]
            : theme.colors.gray[1],
        color: theme.colors[theme.primaryColor][7],
        textDecoration: "none"
    },
    chevron: {
        transition: "transform 200ms ease"
    },
    chevronOpened: {
        transform: `rotate(${theme.dir === "rtl" ? -90 : 90}deg)`
    },
    visible: {
        visibility: "visible"
    },
    hidden: {
        visibility: "hidden"
    },
    smallMenu: {
        width: `calc(24px + ${theme.spacing.md}px)`,
        paddingLeft: '0px'
    }
}));
function CxNavbarItem(menuItem) {
    const { classes, theme, cx } = useStyles();
    const [opened, setOpened] = (0, react_1.useState)(true);
    const ChevronIcon = theme.dir === "ltr" ? free_solid_svg_icons_1.faChevronRight : free_solid_svg_icons_1.faChevronLeft;
    const hasLink = menuItem.link !== undefined;
    const location = (0, react_router_dom_1.useLocation)();
    const isCurrentPath = function (itemPath, itemPaths) {
        let pathExactMatch = (0, react_router_dom_1.useMatch)(itemPath);
        if (pathExactMatch) {
            return true;
        }
        //look ahead
        console.log("Nav Bar execution...");
        let found = itemPaths.find(x => x === location.pathname);
        if (found != null) {
            return false;
        }
        let fuzzyParentMatch = location.pathname.split('/');
        fuzzyParentMatch.shift();
        let parentPath = `/${fuzzyParentMatch ? fuzzyParentMatch[0] : ""}`;
        if (parentPath.toLowerCase() === itemPath.toLowerCase()) {
            return true;
        }
        return false;
    };
    const hasItems = Array.isArray(menuItem.items);
    let pathList = [];
    if (hasItems && menuItem.items) {
        pathList = menuItem.items.map(x => x.link ?? "");
    }
    const items = (hasItems && menuItem.items !== undefined ? menuItem.items : []).map((item, index) => (React.createElement(core_1.Anchor, { key: index, component: react_router_dom_1.Link, className: cx(classes.navbarItemLink, { [classes.navbarItemLinkActive]: isCurrentPath(item.link ?? "", pathList) }), 
        //to={`${useCxAppBasename()}${item.link}`}
        to: `${item.link}` }, item.label ?? "")));
    return hasLink ? (React.createElement(core_1.UnstyledButton, { className: classes.navbarItemControl, component: react_router_dom_1.Link, 
        //to={`${useCxAppBasename()}${menuItem.link}`}
        to: `${menuItem.link}` },
        React.createElement(core_1.Group, { spacing: 0 },
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ChevronIcon, fixedWidth: true, className: classes.hidden }),
            React.createElement(core_1.Text, { ml: "xs", fw: 700 }, menuItem.label ?? "")))) : (React.createElement(React.Fragment, null,
        React.createElement(core_1.UnstyledButton, { onClick: () => setOpened((o) => !o), className: classes.navbarItemControl },
            React.createElement(core_1.Group, { spacing: 0 },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ChevronIcon, fixedWidth: true, className: cx(classes.chevron, opened && classes.chevronOpened, hasItems ? classes.visible : classes.hidden) }),
                React.createElement(core_1.Text, { ml: "xs", fw: 700 }, menuItem.label ?? ""))),
        hasItems ? React.createElement(core_1.Collapse, { in: opened }, items) : null));
}
function CxNavbar(props) {
    const { classes, cx } = useStyles();
    //const links =<></>
    const [isSmallMenu, resizeMenuHandler] = (0, hooks_1.useDisclosure)(false);
    const [isSmallDisplay, smallDisplayMenuHandler] = (0, hooks_1.useDisclosure)(false);
    const links = props.menu.map((item, index) => React.createElement(CxNavbarItem, { key: index, ...item }));
    return (React.createElement(React.Fragment, null,
        React.createElement(styles_1.Global, { styles: (theme) => {
                return ({
                    ":root": {
                        "--cx-navbar-height": `calc(100vh - var(--mantine-header-height, 0px) - ${theme.spacing.md}px - ${theme.spacing.md}px)`
                    }
                });
            } }),
        React.createElement(core_1.Affix, { className: classes.burger, position: { bottom: 8, right: 8 } },
            React.createElement(core_1.Avatar, { radius: "xl", size: "sm" },
                React.createElement(core_1.Burger, { size: "sm", opened: isSmallDisplay, onClick: () => smallDisplayMenuHandler.toggle() }))),
        React.createElement(core_1.Navbar, { hidden: !isSmallDisplay || isSmallMenu, hiddenBreakpoint: "xs", width: { sm: isSmallMenu ? 40 : 240 }, p: "md", className: classes.navbar, 
            //className={cx(classes.navbar, {[classes.smallMenu] : isSmallMenu == true})}
            withBorder: false },
            React.createElement(core_1.Navbar.Section, { className: classes.navbarHeader, hidden: isSmallMenu },
                React.createElement(core_1.Group, { position: "apart", spacing: "xs" },
                    React.createElement(core_1.Text, { size: "sm", weight: 700 }, props.title),
                    props.version && React.createElement(core_1.Code, null,
                        "v",
                        props.version))),
            React.createElement(core_1.Navbar.Section, { hidden: isSmallMenu, grow: true, className: classes.navbarLinks, component: core_1.ScrollArea },
                React.createElement("div", { className: classes.navbarLinksInner }, links)),
            React.createElement(core_1.Navbar.Section, null,
                React.createElement(core_1.Flex, { mih: isSmallMenu ? "var(--cx-navbar-height, 0px)" : 0, align: "flex-end", justify: isSmallMenu ? "center" : "flex-end" },
                    React.createElement(core_1.ActionIcon, { size: "xl", className: classes.resize, onClick: () => {
                            resizeMenuHandler.toggle();
                        }, variant: "transparent" },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "xl", icon: isSmallMenu ? free_solid_svg_icons_1.faChevronCircleRight : faChevronCircleLeft_1.faChevronCircleLeft })))))));
}
exports.CxNavbar = CxNavbar;
//# sourceMappingURL=CxNavbar.js.map